import {HttpClient} from "@angular/common/http";
import {Injectable} from '@angular/core';
import {environment} from "@environments/environment";
import {Observable} from "rxjs";
import {EnumResponse} from '@core/models/enum-response';

export interface RepresentacaoGovbrCadastroPayload {
  id?: number;
  idTipoRepresentacao?: number | null;
  email?: string;
  nomeOrganizacao?: string;
  cnpj?: string;
  cargo?: string;
  cep?: string;
  logradouro?: string;
  numero?: string;
  complemento?: string;
  bairro?: string;
  municipio?: string;
  uf?: string;
  arquivo?: string;
}


@Injectable({
  providedIn: 'root'
})
export class TipoRepresentacaoService {
  private readonly uri = environment.api.uri;


  constructor(private readonly http: HttpClient) {
  }

  save(payload: FormData): Observable<RepresentacaoGovbrCadastroPayload> {
    return this.http.post<RepresentacaoGovbrCadastroPayload>(`${this.uri}representacao`, payload);
  }

  getEnums(): Observable<EnumResponse[]> {
    return this.http.get<EnumResponse[]>(`${this.uri}tipo-representacao`);
  }
}
